import { client } from "../../../shared/services/client";
import { AxiosResponse } from "axios";
import UploadSessionResponse from "../model/UploadSessionResponse";
import UploadChunkResponse from "../model/UploadChunkResponse";
import UploadCommissionFileResponse from "../model/UploadCommissionFileResponse";
import ConvertCommissionFileResponse from "../model/ConvertCommissionFileResponse";
import MigrateCommissionFileResponse from "../model/MigrateCommissionFileResponse";

const accountingBaseKey: string = "accounting";

class ImportCommissionAPI {

    uploadCommissionFile = async ( payload : {
        file: Blob,
        fileName: string,
        carrierName: string,
        statementMonth: string;
    }
    ): Promise<UploadCommissionFileResponse> => {
        client.setBaseURLForService(accountingBaseKey);
        const url = `/api/Accounting/import/upload`;

        const formData = new FormData();
        formData.append("file", payload.file, payload.fileName);
        formData.append("carrierName", payload.carrierName);
        formData.append("statementMonth", payload.statementMonth);

        const res: AxiosResponse<UploadCommissionFileResponse> = await client.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return res.data;
    }

    processCommissionFile = async (payload: {
        fileId: string,
        carrierName: string;
    }): Promise<ConvertCommissionFileResponse> => {
        client.setBaseURLForService(accountingBaseKey);
        const url = `/api/Accounting/import/convert`;
        const res: AxiosResponse<ConvertCommissionFileResponse> = await client.post(url, payload);

        return res.data;
    }

    migrateCommissionFile = async (payload: {
        fileId: string,
        carrierName: string;
    }): Promise<MigrateCommissionFileResponse> => {
        client.setBaseURLForService(accountingBaseKey);
        const url = `/api/Accounting/import/migrate`;
        const res: AxiosResponse<MigrateCommissionFileResponse> = await client.post(url, payload);

        return res.data;
    }

	// Placeholder code for multipart chunk uploading
    initiateUpload = async (): Promise<UploadSessionResponse> => {
        client.setBaseURLForService(accountingBaseKey);
        const url = `/api/Accounting/import/initiate`;
        const res: AxiosResponse<UploadSessionResponse> = await client.post(url, {});
        return res.data;
    }

    uploadChunk = async (
        uploadSessionId: string,
        chunk: Blob
    ): Promise<UploadChunkResponse> => {
        client.setBaseURLForService(accountingBaseKey);
        const params = new URLSearchParams({
            uploadSessionId: uploadSessionId
        });
        const url = `/api/Accounting/import/chunk?${params.toString()}`;
        const res: AxiosResponse<UploadChunkResponse> = await client.post(url, chunk, {
            headers: {
                "Content-Type": "application/octet-stream"
            }
        });
        return res.data;
    }

    completeUpload = async (payload: {
        uploadSessionId: string,
        fileName: string
    }
    ): Promise<void> => {
        client.setBaseURLForService(accountingBaseKey);
        const url = `/api/Accounting/import/complete`;
        await client.post(url, payload);
    }
}

export default ImportCommissionAPI;